export default __webpack_public_path__ + "static/media/thumbnails_6.b9a0dbd7.jpg";